"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderRoutes = void 0;
/* eslint-disable @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-use-before-define */
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Switch_1 = __importDefault(require("./Switch"));
var Route_1 = require("./Route");
function generatePath(parentPath, path) {
    if (parentPath && Array.isArray(parentPath)) {
        return path;
    }
    if (parentPath && parentPath !== '/') {
        /**
         * 匹配 /a/* 子路由为 /b，最终生成的路由为 /a/b
         */
        if (/\/\*$/.test(parentPath)) {
            return parentPath.replace('/*', path);
        }
        return "" + parentPath + path;
    }
    return path;
}
function getRouteElement(_a) {
    var route = _a.route, index = _a.index, opts = _a.opts;
    var path = generatePath(opts.parentPath, route.path);
    var routeProps = {
        key: route.key || index,
        exact: route.exact,
        strict: route.strict,
        sensitive: route.sensitive,
        path: path,
        title: route.title,
    };
    var isSSR = opts.isSSR, disableRouterGetInitialProps = opts.disableRouterGetInitialProps;
    if (route.redirect) {
        return react_1.default.createElement(react_router_dom_1.Redirect, __assign({}, routeProps, { from: route.path, to: route.redirect }));
    }
    else {
        return typeof window !== 'undefined' && isSSR && !disableRouterGetInitialProps ? (react_1.default.createElement(Route_1.RouteWithGetInitialProps, __assign({}, routeProps, { route: route, disableRouterGetInitialProps: opts.disableRouterGetInitialProps, render: function (props) { return render({ route: route, opts: opts, props: props, parentPath: path }); } }))) : (react_1.default.createElement(Route_1.Route, __assign({}, routeProps, { 
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            render: function (props) { return render({ route: route, opts: opts, props: props, parentPath: path }); } })));
    }
}
function renderRoutes(opts) {
    if (!opts.routes) {
        return;
    }
    var generateRoutes = function () { return (react_1.default.createElement(Switch_1.default, null, opts.routes.map(function (route, index) {
        return getRouteElement({
            route: route,
            index: index,
            opts: opts,
        });
    }))); };
    return generateRoutes();
}
exports.renderRoutes = renderRoutes;
function render(_a) {
    var route = _a.route, opts = _a.opts, props = _a.props, parentPath = _a.parentPath;
    var routes = renderRoutes(__assign(__assign({}, opts), { parentPath: parentPath, routes: route.routes || [] }));
    var Component = route.component, wrappers = route.wrappers;
    if (Component) {
        var defaultPageInitialProps = !opts.isBrowser ? {} : window.g_initialProps;
        var newProps = __assign(__assign(__assign({}, props), (opts.pageInitialProps || defaultPageInitialProps)), { route: route });
        var ret = react_1.default.createElement(Component, __assign({}, newProps), routes);
        // route.wrappers
        if (wrappers) {
            var len = wrappers.length - 1;
            while (len >= 0) {
                ret = react_1.default.createElement(wrappers[len], newProps, ret);
                len -= 1;
            }
        }
        return ret;
    }
    else {
        return routes;
    }
}
//# sourceMappingURL=renderRoutes.js.map